import { render, staticRenderFns } from "./ServiceListDialog.vue?vue&type=template&id=78a5064e&scoped=true&"
import script from "./ServiceListDialog.vue?vue&type=script&lang=js&"
export * from "./ServiceListDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a5064e",
  null
  
)

export default component.exports